import React from 'react'
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

export interface ConfirmDialogState {
  open: boolean
  objectId?: string
}

export interface ConfirmDialogProps {
  body: string
  close: () => void
  confirm: () => void
  confirmText: string
  disableActions: boolean
  open: boolean
  title: string
  showCancel?: boolean
  alertProps?: AlertProps
  confirmColor?: 'primary' | 'error'
  // Keep the dialog open after confirming, e.g. while a mutation is in
  // flight and the caller closes it from onCompleted.
  closeOnConfirm?: boolean
  loading?: boolean
}

export interface AlertProps {
  variant: 'outlined' | 'filled' | 'standard' | undefined
  severity: 'error' | 'warning' | 'info' | 'success'
  body: string
}

const ConfirmDialog = ({
  body,
  close,
  confirm,
  confirmText,
  disableActions,
  open,
  title,
  showCancel,
  alertProps,
  confirmColor,
  closeOnConfirm,
  loading,
}: ConfirmDialogProps) => {
  const handleConfirm = () => {
    if (closeOnConfirm ?? true) {
      close()
    }
    confirm()
  }
  return (
    <>
      <Dialog open={open} onClose={close}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent style={{ width: '30em', whiteSpace: 'pre-line' }}>
          {alertProps && (
            <Alert
              variant={alertProps.variant || 'standard'}
              severity={alertProps.severity}
              style={{ marginBottom: '1em' }}
            >
              {alertProps.body}
            </Alert>
          )}
          <DialogContentText>{body}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {(showCancel == null || showCancel) && (
            <Button
              onClick={close}
              variant="outlined"
              disabled={disableActions || loading}
            >
              Cancel
            </Button>
          )}
          <Button
            onClick={handleConfirm}
            variant="contained"
            color={confirmColor ?? 'primary'}
            disabled={disableActions || loading}
            startIcon={
              loading ? (
                <CircularProgress size={16} color="inherit" />
              ) : undefined
            }
          >
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ConfirmDialog
